import type {
  Director,
  DirectorAuthority,
  DirectorInput,
  RepresentationAuthority,
} from 'generated/gql';

export const mapDirectorToDirectorInput = (director: Partial<Director>): DirectorInput => ({
  authority: director.authority as DirectorAuthority,
  directorPartyId: director.director?.id || '',
  representationAuthority: director.representationAuthority as RepresentationAuthority,
  title: director.title,
});
